export default "__VITE_PUBLIC_ASSET__fe9d7e29__"